self.debounce = function debounce(func, options) {
    let timeoutId = null;
    let maxTimeoutId = null;
    const { wait, maxTimeout } = options;
    return function (...args) {
        const context = this;
        // Clear the existing timeout
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        // If maxTimeout is set, ensure the function is called at least once within that time
        if (maxTimeout && !maxTimeoutId) {
            maxTimeoutId = setTimeout(() => {
                func.apply(context, args);
                maxTimeoutId = null;
                timeoutId = null;
            }, maxTimeout);
        }
        // Set a new timeout
        timeoutId = setTimeout(() => {
            // Clear the max timeout if it exists
            if (maxTimeoutId) {
                clearTimeout(maxTimeoutId);
                maxTimeoutId = null;
            }
            // Execute the function
            func.apply(context, args);
            timeoutId = null;
        }, wait);
    };
}
